export const TEST_3_DECIMALS = new RegExp(`\\.\\d{3,}$`); // Regex to test if there are 3 or more digits after dot
export const TEST_1_DECIMAL = new RegExp(`\\.\\d{1,}$`); // Regex to test if there are 1 or more digits after dot

/** Given number and abbreviation, it will return the stringified annotated version of the number */
const annotate = (number: number, abbr: string) => {
  let rounded = 0;
  switch (abbr) {
    case 'T':
      rounded = number / 1e12;
      break;
    case 'B':
      rounded = number / 1e9;
      break;
    case 'M':
      rounded = number / 1e6;
      break;
    case 'k':
      rounded = number / 1e3;
      break;
    default:
      rounded = number;
      break;
  }

  if (TEST_3_DECIMALS.test(`${rounded}`)) {
    rounded = Number(rounded.toFixed(2));
  }
  return rounded.toLocaleString() + abbr;
};

/** Given the number it will return the abbreviation of the number. e.g. "2.34M" */
export const abbreviate = (number: number) => {
  let abbr = '';
  if (number >= 1e12) {
    abbr = 'T';
  } else if (number >= 1e9) {
    abbr = 'B';
  } else if (number >= 1e6) {
    abbr = 'M';
  } else if (number >= 1e3) {
    abbr = 'k';
  }
  return annotate(number, abbr);
};

export const formatPercentage = (percentage: number) => {
  if (TEST_3_DECIMALS.test(`${percentage}`)) {
    return `${percentage.toFixed(2)}%`;
  } else {
    return `${percentage}%`;
  }
};

/**
 * compareScrollAndClientWidthSize
 * used in AnalyticsCard to verify whether text should be truncated, which
 * it should be if the scrollWidth of the card is larger than the clientWidth
 */
export const compareScrollAndClientWidthSize = (
  scrollWidth?: number,
  clientWidth?: number,
): boolean => {
  return scrollWidth && clientWidth ? scrollWidth > clientWidth : false;
};
